export const environmentDev = {
    fields:[
    {
      "position": 1,
      "type_id": 7,
      "slug": "resources",
      "type": "Ресурси",
      "icon": "source_environment",
      "comment": "Опис для Ресурси"
    },
    {
      "position": 2,
      "type_id": 10,
      "slug": "force-majeure",
      "type": "Форс мажор",
      "icon": "nearby_error",
      "comment": "Опис для Форс мажор"
    },
    {
      "position": 3,
      "type_id": 111,
      "slug": "deals",
      "type": "Угоди",
      "icon": "handshake",
      "comment": "Опис для Угоди"
    },
    {
      "position": 4,
      "type_id": 8,
      "slug": "clean-money",
      "type": "Місяць",
      "icon": "payments",
      "comment": "Виплата грошей готівкою. Зміна часу на 1 міс. Можна змінити умови відповідно до Ролі"
    },
    {
      "position": 5,
      "type_id": 5,
      "slug": "actions",
      "type": "Дії",
      "icon": "touch_app",
      "comment": "Опис для Дії"
    },
    {
      "position": 6,
      "type_id": 7, // quez
      "slug": "child",
      "type": "Дитина",
      "icon": "crib",
      "comment": "Разова допомога 3 000 ЕКЮ, впливає на Готівку та Щомісячні витрати"
    },
    {
      "position": 7,
      "type_id": 10,
      "slug": "resources",
      "type": "Ресурси",
      "icon": "source_environment",
      "comment": "Опис для Ресурси"
    },
    {
      "position": 8,
      "type_id": 2,
      "slug": "deals",
      "type": "Угоди",
      "icon": "handshake",
      "comment": "Опис для Угоди"
    },
    {
      "position": 9,
      "type_id": 5,
      "slug": "little-weaknesses",
      "type": "Маленькі слабкості",
      "icon": "sports_esports",
      "comment": "Опис для Маленькі слабкості"
    },
    {
      "position": 10,
      "type_id": 4,
      "slug": "force-majeure",
      "type": "Форс мажор",
      "icon": "nearby_error",
      "comment": "Опис для Форс мажор"
    },
    {
      "position": 11,
      "type_id": 2,
      "slug": "deals",
      "type": "Угоди",
      "icon": "handshake",
      "comment": "Опис для Угоди"
    },
    {
      "position": 12,
      "type_id": 8,
      "slug": "clean-money",
      "type": "Місяць",
      "icon": "payments",
      "comment": "Виплата грошей готівкою. Зміна часу на 1 міс. Можна змінити умови відповідно до Ролі"
    },
    {
      "position": 13,
      "type_id": 2,
      "slug": "deals",
      "type": "Угоди",
      "icon": "handshake",
      "comment": "Опис для Угоди"
    },
    {
      "position": 14,
      "type_id": 4,
      "slug": "little-weaknesses",
      "type": "Маленькі слабкості",
      "icon": "sports_esports",
      "comment": "Опис для Маленькі слабкості"
    },
    {
      "position": 15,
      "type_id": 5,
      "slug": "resources",
      "type": "Ресурси",
      "icon": "source_environment",
      "comment": "Опис для Ресурси"
    },
    {
      "position": 16,
      "type_id": 2,
      "slug": "deals",
      "type": "Угоди",
      "icon": "handshake",
      "comment": "Опис для Угоди"
    },
    {
      "position": 17,
      "type_id": 4,
      "slug": "force-majeure",
      "type": "Форс мажор",
      "icon": "nearby_error",
      "comment": "Опис для Форс мажор"
    },
    {
      "position": 18,
      "type_id": 5,
      "slug": "actions",
      "type": "Дії",
      "icon": "touch_app",
      "comment": "Опис для Дії"
    },
    {
      "position": 19,
      "type_id": 8, // шутка дня
      "slug": "dismissal",
      "type": "Звільнення",
      "icon": "logout",
      "comment": "Якщо найманий працівник! Ходить далі, поки не пройде 3 \"Чисті гроші\", не отримує ЗП"
    },
    {
      "position": 20,
      "type_id": 5,
      "slug": "clean-money",
      "type": "Місяць",
      "icon": "payments",
      "comment": "Виплата грошей готівкою. Зміна часу на 1 міс. Можна змінити умови відповідно до Ролі"
    },
    {
      "position": 21,
      "type_id": 2,
      "slug": "little-weaknesses",
      "type": "Маленькі слабкості",
      "icon": "sports_esports",
      "comment": "Опис для Маленькі слабкості"
    },
    {
      "position": 22,
      "type_id": 5,
      "slug": "actions",
      "type": "Дії",
      "icon": "touch_app",
      "comment": "Опис для Дії"
    },
    {
      "position": 23,
      "type_id": 8, // шутка дня
      "slug": "tax-audit",
      "type": "Податкова перевірка",
      "icon": "markdown_paste",
      "comment": "Якщо є бізнес – віддати 10% з готівки?"
    },
    {
      "position": 24,
      "type_id": 10, // 10 питань
      "slug": "charity",
      "type": "Благодійність",
      "icon": "real_estate_agent",
      "comment": "Благодійність ..."
    }
  ],
  cards:[
    {
    "card_id": 5002,
    "type_id": 5,
    "quest_id": 1,
    "name": "СПРАВКА. Что происходит, когда вы не высыпаетесь?",
    "active": true,
    "data": {
      "human_descrition": {
        "text": "СПРАВКА. Что происходит, когда вы не высыпаетесь?",
        "name": "Недосып и ночные пробуждения — это не просто усталость. Нарушается работа мозга, снижается внимание, страдает память и настроение. Иммунитет слабеет, гормоны сбиваются, а обмен веществ замедляется. Это прямой путь к выгоранию, частым болезням и набору веса. <br><br>💡 Свет и шум — скрытые враги сна<br>Даже приглушённый свет от экрана или уличного фонаря снижает выработку мелатонина — гормона сна и восстановления. Шум (даже если вы его почти не слышите) — это постоянный микростресс для нервной системы. Организм не расслабляется по-настоящему.<br><br>🍽️ Почему питание — это защита?<br> Полноценный рацион с магнием, витаминами группы B, омега-3 и антиоксидантами помогает нервной системе справляться со стрессом, вырабатывать «гормоны спокойствия» и восстанавливаться ночью. Без этих нутриентов мозг работает «на пустом баке». <br>🕐 Что помогает наладить режим?<br>· Ложитесь до 23:00 — в это время активно идёт восстановление.<br>· За 2 часа до сна — никаких гаджетов и яркого света.<br>· Тепло, тишина и темнота — лучшие друзья глубокого сна.<br>· Ужин лёгкий, без кофеина и сахара.<br>· Если нет ресурса — поддержите себя питанием: это не слабость, а грамотная забота о себе."
      },
      "influence": {
        "is_mandatory": true,
        "other": false,
        "card_type": "informations",
      }
    }

},{
    "card_id": 5005,
    "type_id": 8080,
    "quest_id": 1,
    "name": "СПРАВКА. Полноценный сон и восстановление ресурсного состояния",
    "active": true,
    "data": {
      "human_descrition": {
        "text": "СПРАВКА. Полноценный сон и восстановление ресурсного состояния",
        "name": "😴 Зачем нужен сон?<br/>Сон — это не отдых «по остаточному принципу». Во сне восстанавливаются гормоны, иммунитет, память, энергия. Ночью идёт детоксикация мозга и тела, синтезируются нейромедиаторы, перерабатываются эмоции.<br/>🚨 Что происходит при дефиците сна и сбитом режиме?<br/>· Повышается уровень кортизола (гормона стресса)<br/>· Нарушается метаболизм, увеличивается тяга к сладкому<br/>· Ослабляется иммунитет, растёт воспаление<br/>· Ухудшается настроение, память и концентрация<br/>· Замедляется восстановление, повышается тревожность и риск выгорания<br/>🔦 Свет и шум ночью — скрытые разрушители<br/>Свет подавляет мелатонин — гормон сна, антиоксидант и регулятор биоритмов. Шум (даже фоновый) возбуждает нервную систему, мешая глубокому сну и восстановлению.<br/>🧩 Чем помогают нутриенты?<br/>· Магний — успокаивает, улучшает качество сна, регулирует нейротрансмиттеры<br/>· Кальций и цинк — участвуют в синтезе мелатонина<br/>· Омега-3 — поддерживает нервную ткань и эмоциональный баланс<br/>· Лецитин — улучшает работу мозга и снабжение клеток энергией<br/>· Витамины группы B — регулируют цикл бодрствования–сна и устойчивость к стрессу<br/>· Аминокислоты (триптофан, глицин) — предшественники серотонина и мелатонина<br/>· Полезная микрофлора и клетчатка — влияют на синтез нейромедиаторов в кишечнике<br/>💡 Почему с нутриентами легче?<br/>Организм легче успокаивается, быстрее засыпает, восстанавливает энергию и эмоциональную устойчивость. Без нужных веществ мозг и тело «зависают» в режиме тревоги и не могут полноценно восстановиться.<br/>✅ Общие рекомендации по режиму:<br/>· Ложитесь до 23:00, без гаджетов за 1,5–2 часа<br/>· Спите в полной темноте и тишине<br/>· Ужин — за 2–3 часа до сна, без тяжёлой еды<br/>· Создайте вечерние ритуалы (ванна, дыхание, тёплый чай без кофеина)<br/>· Поддержите организм питанием — это ключ к реальному восстановлению"
      },
      "influence": {
        "is_mandatory": true,
        "other": false,
        "card_type": "informations",
      }
    }
  },{
    "card_id": 8015,
    "type_id": 8,
    "quest_id": 1,
    "name": "🛌 А ВЫ ЗНАЛИ, ЧТО БЕЗОПАСНОЕ ПОХУДЕНИЕ НАЧИНАЕТСЯ СО СНА?",
    "active": true,
    "data": {
      "human_descrition": {
        "text": "🛌 А ВЫ ЗНАЛИ, ЧТО БЕЗОПАСНОЕ ПОХУДЕНИЕ НАЧИНАЕТСЯ СО СНА?",
        "name": "Дефицит сна — не просто усталость. Это гормональный хаос. <br>😵‍💫 Когда вы не высыпаетесь, растёт выработка грелина — гормона голода, и снижается лептин — гормона насыщения. В результате: <br>🍩 тянет на сладкое и быстрые углеводы<br>🍕 усиливается вечерний аппетит<br>📉 снижается метаболизм и сгорает меньше калорий<br>😓 тело «в панике» запасает жир — особенно на животе<br>💡 Недосып = риск набора массы, инсулинорезистентности, воспаления и хронической усталости.<br>🛠 Что помогает:<br>• Ложитесь до 23:00<br>• Спите в полной темноте, без шума<br>• Поддержите себя нутриентами: магний, омега-3, белок, витамины группы B, микрофлора, клетчатка<br>• Ужин — лёгкий, без сахара и кофеина<br>• Пейте достаточно чистой воды <br>✨ Здоровый сон = запуск сжигания жира, восстановление гормонального фона и снижение тяги к еде."
      },
      "influence": {
        "is_mandatory": true,
        "other": false,
        "card_type": "informations",
      }
    }
  },{
    "card_id": 8075,
    "type_id": 8040,
    "quest_id": 1,
    "name": "🛌 А ВЫ ЗНАЛИ, ЧТО БЕЗОПАСНОЕ ПОХУДЕНИЕ НАЧИНАЕТСЯ СО СНА?",
    "active": true,
    "data": {
      "human_descrition": {
        "text": "🛌 А ВЫ ЗНАЛИ, ЧТО БЕЗОПАСНОЕ ПОХУДЕНИЕ НАЧИНАЕТСЯ СО СНА?",
        "name": "Дефицит сна — не просто усталость. Это гормональный хаос. <br>😵‍💫 Когда вы не высыпаетесь, растёт выработка грелина — гормона голода, и снижается лептин — гормона насыщения. В результате: <br>🍩 тянет на сладкое и быстрые углеводы<br>🍕 усиливается вечерний аппетит<br>📉 снижается метаболизм и сгорает меньше калорий<br>😓 тело «в панике» запасает жир — особенно на животе<br>💡 Недосып = риск набора массы, инсулинорезистентности, воспаления и хронической усталости.<br>🛠 Что помогает:<br>• Ложитесь до 23:00<br>• Спите в полной темноте, без шума<br>• Поддержите себя нутриентами: магний, омега-3, белок, витамины группы B, микрофлора, клетчатка<br>• Ужин — лёгкий, без сахара и кофеина<br>• Пейте достаточно чистой воды <br>✨ Здоровый сон = запуск сжигания жира, восстановление гормонального фона и снижение тяги к еде."
      },
      "influence": {
        "is_mandatory": true,
        "other": false,
        "card_type": "informations",
      }
    }
  },{
    "card_id": 7001,
    "type_id": 7,
    "name": "Что происходит в организме при хроническом дефиците сна?",
    "active": true,
    "data": {
      "human_descrition": {
        "text": "Что происходит в организме при хроническом дефиците сна?",
        "name": "Что происходит в организме при хроническом дефиците сна?"
      },
      "influence": {
        "is_mandatory": true,
        "other": true,
        "card_type": "QUIZ"
      },
      "variants_type": "checkbox",
      "card_points": 40,
      "variants": [
        {
          "variant_name": "Повышается уровень кортизола и риск воспаления",
          "v_points": 10,
        },
        {
          "variant_name": "Ухудшается работа мозга, памяти и концентрации",
          "v_points": 10,
        },
        {
          "variant_name": "Замедляется обмен веществ, растёт тяга к сладкому",
          "v_points": 10,
        },
        {
          "variant_name": "Ослабляется иммунитет и гормональный фон",
          "v_points": 10,
        },
        {
          "variant_name": "Сон помогает быстрее набирать вес и повышает аппетит",
          "v_points": -10,
        }
      ]
    }
  },{
    "card_id": 3003,
    "type_id": 8020, // КВИЗ: Что вы знаете о сне и восстановлении?
    "quest_id": 1,
    "name": "❷ Как свет и шум нарушают ночной отдых?",
    "active": true,
    "data": {
      "human_descrition": {
        "text": "❷ Как свет и шум нарушают ночной отдых?",
        "name": "❷ Как свет и шум нарушают ночной отдых?"
      },
      "influence": {
        "is_mandatory": true,
        "other": true,
        "card_type": "QUIZ"
      },
      "variants_type": "checkbox",
      "card_points": 40,
      "variants": [
        {
          "variant_name": "🔹 Свет подавляет выработку мелатонина",
          "v_points": 10,
        },
        {
          "variant_name": "🔹 Даже слабый шум вызывает микростресс",
          "v_points": 10,
        },
        {
          "variant_name": "🔹 Шум мешает глубокой фазе сна",
          "v_points": 10,
        },
        {
          "variant_name": "🔹 Яркий экран вечером сбивает биоритмы",
          "v_points": 10,
        },
        {
          "variant_name": "❌ Звук телевизора на фоне улучшает качество сна",
          "v_points": -10,
        }
      ]
    }
  },{
    "card_id": 3005,
    "type_id": 3, // КВИЗ: Что вы знаете о сне и восстановлении?
    "quest_id": 1,
    "name": "❸ Почему магний важен для сна и восстановления?",
    "active": true,
    "data": {
      "human_descrition": {
        "text": "❸ Почему магний важен для сна и восстановления?",
        "name": "❸ Почему магний важен для сна и восстановления?"
      },
      "influence": {
        "is_mandatory": true,
        "other": true,
        "card_type": "QUIZ"
      },
      "variants_type": "checkbox",
      "card_points": 40,
      "variants": [
        {
          "variant_name": "🔹 Поддерживает выработку мелатонина",
          "v_points": 10,
        },
        {
          "variant_name": "🔹 Способствует выработке нейромедиаторов",
          "v_points": 10,
        },
        {
          "variant_name": "❌ Заменяет полноценный сон при хроническом недосыпе",
          "v_points": -10,
        },
        {
          "variant_name": "🔹 Участвует в регуляции нервной системы",
          "v_points": 10,
        },
        {
          "variant_name": "🔹 Помогает расслабиться и легче заснуть",
          "v_points": 10,
        }
      ]
    }
  },{
    "card_id": 1001,
    "type_id": 10, // "Какие нутриенты восстанавливают то, что страдает от нарушенного режима и дефицита сна"
    "quest_id": 1,
    "name": "❶ Что помогает мозгу восстановиться после недосыпа и переутомления?",
    "active": true,
    "data": {
      "human_descrition": {
        "text": "❶ Что помогает мозгу восстановиться после недосыпа и переутомления?",
        "name": "❶ Что помогает мозгу восстановиться после недосыпа и переутомления?"
      },
      "influence": {
        "is_mandatory": true,
        "other": true,
        "card_type": "nutrients_restore"
      },
      "variants_type": "checkbox",
      "card_points": 30,
      "variants": [
        {
          "variant_name": "🔹 Магний",
          "v_points": 10,
        },
        {
          "variant_name": "❌ Сахар",
          "v_points": -10,
        },
        {
          "variant_name": "❌ Энергетические напитки",
          "v_points": -10,
        },
        {
          "variant_name": "🔹 Лецитин",
          "v_points": 10,
        },
        {
          "variant_name": "🔹 Витамины группы B",
          "v_points": 10,
        }
      ]
    }
  },{
    "card_id": 1006,
    "type_id": 7010, // "Какие нутриенты восстанавливают то, что страдает от нарушенного режима и дефицита сна"
    "quest_id": 1,
    "name": "❷ Какие нутриенты поддерживают гормональный баланс при сбитом режиме сна?",
    "active": true,
    "data": {
      "human_descrition": {
        "text": "❷ Какие нутриенты поддерживают гормональный баланс при сбитом режиме сна?",
        "name": "❷ Какие нутриенты поддерживают гормональный баланс при сбитом режиме сна?"
      },
      "influence": {
        "is_mandatory": true,
        "other": true,
        "card_type": "nutrients_restore"
      },
      "variants_type": "checkbox",
      "card_points": 30,
      "variants": [
        {
          "variant_name": "🔹 Цинк",
          "v_points": 10,
        },
        {
          "variant_name": "❌ Желатин",
          "v_points": -10,
        },
        {
          "variant_name": "❌ Газировка",
          "v_points": -10,
        },
        {
          "variant_name": "🔹 Омега-3",
          "v_points": 10,
        },
        {
          "variant_name": "🔹 Витамин D",
          "v_points": 10,
        }
      ]
    }
  },{
    "card_id": 1020,
    "type_id": 1, // "Какие нутриенты восстанавливают то, что страдает от нарушенного режима и дефицита сна"
    "quest_id": 1,
    "name": "❽ Какие нутриенты и привычки защищают от светового и шумового загрязнения во сне?",
    "active": true,
    "data": {
      "human_descrition": {
        "text": "❽ Какие нутриенты и привычки защищают от светового и шумового загрязнения во сне?",
        "name": "❽ Какие нутриенты и привычки защищают от светового и шумового загрязнения во сне?"
      },
      "influence": {
        "is_mandatory": true,
        "other": true,
        "card_type": "nutrients_restore"
      },
      "variants_type": "checkbox",
      "card_points": 10,
      "variants": [
        {
          "variant_name": "🔹 Магний",
          "v_points": 10,
        },
        {
          "variant_name": "❌ Сахар",
          "v_points": -10,
        },
        {
          "variant_name": "❌ Энергетические напитки",
          "v_points": -10,
        },
        {
          "variant_name": "🔹 Лецитин",
          "v_points": 10,
        },
        {
          "variant_name": "🔹 Витамины группы B",
          "v_points": 10,
        }
      ]
    }
  },{
    "card_id": 1001,
    "type_id": 111, // "Какие нутриенты восстанавливают то, что страдает от нарушенного режима и дефицита сна"
    "quest_id": 1,
    "name": "❶ Что помогает мозгу восстановиться после недосыпа и переутомления?",
    "active": true,
    "data": {
      "human_descrition": {
        "text": "❶ Что помогает мозгу восстановиться после недосыпа и переутомления?",
        "name": "❶ Что помогает мозгу восстановиться после недосыпа и переутомления?"
      },
      "influence": {
        "is_mandatory": true,
        "other": true,
        "card_type": "nutrients_restore"
      },
      "variants_type": "radiobutton",
      "card_points": 10,
      "variants": [
        {
          "variant_name": "❌ Магний",
          "v_points": -10,
        },
        {
          "variant_name": "❌ Сахар",
          "v_points": -10,
        },
        {
          "variant_name": "❌ Энергетические напитки",
          "v_points": -10,
        },
        {
          "variant_name": "🔹 Лецитин",
          "v_points": 10,
        },
        {
          "variant_name": "❌ Витамины группы B",
          "v_points": -10,
        }
      ]
    }
  },{
    "card_id": 2020,
    "type_id": 2, // 10 справок о механизмах восстановления после дефицита сна и отдыха с конкретным действием нутриентов, как вы просили. Каждая карточка описывает что нарушается при недосыпе и как конкретные нутриенты помогают восстановить функции организма:
    "quest_id": 1,
    "name": "❶ Магний: нейрорелаксант и стабилизатор",
    "active": true,
    "data": {
      "human_descrition": {
        "text": "❶ Магний: нейрорелаксант и стабилизатор",
        "name": "🧠 При дефиците сна нейроны становятся гипервозбудимыми. Это мешает расслабиться и засыпать.<br>🛠 Магний связывается с ГАМК-рецепторами в мозге — это главный тормозной нейромедиатор. Он снижает возбуждение, расслабляет мышцы, стабилизирует сердечный ритм и помогает уснуть."
      },
      "influence": {
        "is_mandatory": true,
        "other": false,
        "card_type": "recovery_mechanism"
      },
    }
  },{
    "card_id": 2010,
    "type_id": 2, // 10 справок о механизмах восстановления после дефицита сна и отдыха с конкретным действием нутриентов, как вы просили. Каждая карточка описывает что нарушается при недосыпе и как конкретные нутриенты помогают восстановить функции организма:
    "quest_id": 1,
    "name": "❶ Магний: нейрорелаксант и стабилизатор",
    "active": true,
    "data": {
      "human_descrition": {
        "text": "❷ Омега-3: мембраны и настроение",
        "name": "💤 При хроническом недосыпе ухудшается структура нейрональных мембран. Это влияет на передачу сигналов, настроение, регуляцию сна.<br/>🛠 Омега-3 жирные кислоты (EPA и DHA) встраиваются в мембраны нейронов, делая их более гибкими. Это улучшает связь между клетками мозга, снижает тревожность и улучшает настроение."
      },
      "influence": {
        "is_mandatory": true,
        "other": false,
        "card_type": "recovery_mechanism"
      },
    }
  },{
    "card_id": 2015,
    "type_id": 7080, // 10 справок о механизмах восстановления после дефицита сна и отдыха с конкретным действием нутриентов, как вы просили. Каждая карточка описывает что нарушается при недосыпе и как конкретные нутриенты помогают восстановить функции организма:
    "quest_id": 1,
    "name": "❸ Лецитин: питание мозга",
    "active": true,
    "data": {
      "human_descrition": {
        "text": "❸ Лецитин: питание мозга",
        "name": "💤 Без сна ухудшается память, концентрация, выработка ацетилхолина — нейромедиатора обучения.<br/>🛠 Лецитин богат фосфатидилхолином — он восстанавливает оболочки нейронов и поддерживает выработку ацетилхолина, улучшая когнитивные функции даже при недосыпе."
      },
      "influence": {
        "is_mandatory": true,
        "other": false,
        "card_type": "recovery_mechanism"
      },
    }
  },{
    "card_id": 4001,
    "type_id": 4, // ЭТО КОНКРЕТНО ПРО СОЛСТИК ЭНЕРДЖИ:
    "quest_id": 1,
    "name": "🔋 Натуральная энергия без перегрузки",
    "active": true,
    "data": {
      "human_descrition": {
        "text": "🔋 Карточка 1: Натуральная энергия без перегрузки",
        "name": "Часто чувствуете усталость и тянетесь к кофе? Но стимуляторы — как кредит: дают взлёт, но потом — спад и опустошение.<br>А что, если можно иначе?<br><br>🌱 Экстракты гуараны и зелёного чая — это мягкая и постепенная стимуляция без скачков давления. Они содержат натуральные источники кофеина, но благодаря сопутствующим веществам (полифенолам) — энергия сохраняется дольше, а перегрузки нет.<br>✨ Добавьте к этому витамины группы B, участвующие в выработке АТФ — и клетки начинают 'заводиться' сами, без подстёгивания нервной системы.<br>💡 Такой подход даёт энергию без стресса, без истощения, с уважением к телу."
      },
      "influence": {
        "is_mandatory": true,
        "other": false,
        "card_type": "SOLSTIK_ENERGY"
      },
    }
  }
  ],
  fieldsList:[{
    sectors:{
      name:"ПЕРВАЯ Четвёрка",
      colorGroup: "#0078D7",
      fields:[{
          "position": 1,
          "type_id": 1,
          "slug": "heart_and_blood",
          "type": "Сердце и сосуды",
          "icon": "source_environment",
          "comment": "Heart and blood vessels"
        },{
          "position": 2,
          "type_id": 2,
          "slug": "lungs_and_oxygen",
          "type": "Лёгкие и кислород",
          "icon": "source_environment",
          "comment": "Lungs and oxygen"
        },{
          "position": 3,
          "type_id": 3,
          "slug": "lymph_and_cleansing",
          "type": "Лимфа и очищение",
          "icon": "source_environment",
          "comment": "Lymph and cleansing"
        },{
          "position": 4,
          "type_id": 4,
          "slug": "water_and_minerals",
          "type": "Вода и минералы",
          "icon": "source_environment",
          "comment": "Water and minerals"
        }
      ]
    }
  },{
    sectors:{
      name:"ВТОРАЯ Четвёрка",
      colorGroup: "#16C60C",
      fields:[{
          "position": 5,
          "type_id": 5,
          "slug": "liver_and_detox",
          "type": "Печень и детокс",
          "icon": "source_environment",
          "comment": "Liver and detox"
        },{
          "position": 6,
          "type_id": 6,
          "slug": "kidneys_and_water",
          "type": "Почки и водный баланс",
          "icon": "source_environment",
          "comment": "Kidneys and water balance"
        },{
          "position": 7,
          "type_id": 7,
          "slug": "protection_from_environmental_threats",
          "type": "Защита от экоугроз",
          "icon": "source_environment",
          "comment": "Protection from environmental threats"
        },{
          "position": 8,
          "type_id": 8,
          "slug": "antioxidants_and_youth",
          "type": "Антиоксиданты и молодость",
          "icon": "source_environment",
          "comment": "Antioxidants and youth"
        }
      ]
    }
  }],
  fieldQuest:[{
    "questName":"Антиоксиданты и молодость",
    "type_id": 8,
    "fields":[{
      "position": 1,
      "type_id": 8080,
      "slug": "resources",
      "type": "Ресурси",
      "icon": "source_environment",
      "comment": "Опис для Ресурси"
    },
    {
      "position": 2,
      "type_id": 8040,
      "slug": "force-majeure",
      "type": "Форс мажор",
      "icon": "nearby_error",
      "comment": "Опис для Форс мажор"
    },
    {
      "position": 3,
      "type_id": 8020,
      "slug": "deals",
      "type": "Угоди",
      "icon": "handshake",
      "comment": "Опис для Угоди"
    }]
  },{
    "questName":"Защита от экоугроз",
    "type_id": 7,
    "fields":[{
      "position": 1,
      "type_id": 8080,
      "slug": "resources",
      "type": "Ресурси",
      "icon": "source_environment",
      "comment": "Опис для Ресурси"
    },
    {
      "position": 2,
      "type_id": 8040,
      "slug": "force-majeure",
      "type": "Форс мажор",
      "icon": "nearby_error",
      "comment": "Опис для Форс мажор"
    },{
      "position": 3,
      "type_id": 7080,
      "slug": "resources",
      "type": "Ресурси",
      "icon": "source_environment",
      "comment": "Опис для Ресурси"
    },
    {
      "position": 4,
      "type_id": 8020,
      "slug": "deals",
      "type": "Угоди",
      "icon": "handshake",
      "comment": "Опис для Угоди"
    },{
      "position": 5,
      "type_id": 7010,
      "slug": "force-majeure",
      "type": "Форс мажор",
      "icon": "nearby_error",
      "comment": "Опис для Форс мажор"
    }]
  },{
    "questName":"Почки и водный баланс",
    "type_id": 6,
    "fields":[
    {
      "position": 1,
      "type_id": 8040,
      "slug": "force-majeure",
      "type": "Форс мажор",
      "icon": "nearby_error",
      "comment": "Опис для Форс мажор"
    },{
      "position": 2,
      "type_id": 7080,
      "slug": "resources",
      "type": "Ресурси",
      "icon": "source_environment",
      "comment": "Опис для Ресурси"
    },
    {
      "position": 3,
      "type_id": 8020,
      "slug": "deals",
      "type": "Угоди",
      "icon": "handshake",
      "comment": "Опис для Угоди"
    },{
      "position": 4,
      "type_id": 7010,
      "slug": "force-majeure",
      "type": "Форс мажор",
      "icon": "nearby_error",
      "comment": "Опис для Форс мажор"
    }]
  },{
    "questName":"Печень и детокс",
    "type_id": 5,
    "fields":[{
      "position": 1,
      "type_id": 8080,
      "slug": "resources",
      "type": "Ресурси",
      "icon": "source_environment",
      "comment": "Опис для Ресурси"
    },
    {
      "position": 2,
      "type_id": 8040,
      "slug": "force-majeure",
      "type": "Форс мажор",
      "icon": "nearby_error",
      "comment": "Опис для Форс мажор"
    },
    {
      "position": 3,
      "type_id": 8020,
      "slug": "deals",
      "type": "Угоди",
      "icon": "handshake",
      "comment": "Опис для Угоди"
    }]
  },{
    "questName":"Вода и минералы",
    "type_id": 4,
    "fields":[{
      "position": 1,
      "type_id": 8080,
      "slug": "resources",
      "type": "Ресурси",
      "icon": "source_environment",
      "comment": "Опис для Ресурси"
    },
    {
      "position": 2,
      "type_id": 8040,
      "slug": "force-majeure",
      "type": "Форс мажор",
      "icon": "nearby_error",
      "comment": "Опис для Форс мажор"
    },{
      "position": 3,
      "type_id": 7080,
      "slug": "resources",
      "type": "Ресурси",
      "icon": "source_environment",
      "comment": "Опис для Ресурси"
    },
    {
      "position": 4,
      "type_id": 8020,
      "slug": "deals",
      "type": "Угоди",
      "icon": "handshake",
      "comment": "Опис для Угоди"
    },{
      "position": 5,
      "type_id": 7010,
      "slug": "force-majeure",
      "type": "Форс мажор",
      "icon": "nearby_error",
      "comment": "Опис для Форс мажор"
    }]
  },{
    "questName":"Лимфа и очищение",
    "type_id": 3,
    "fields":[
    {
      "position": 1,
      "type_id": 8040,
      "slug": "force-majeure",
      "type": "Форс мажор",
      "icon": "nearby_error",
      "comment": "Опис для Форс мажор"
    },{
      "position": 2,
      "type_id": 7080,
      "slug": "resources",
      "type": "Ресурси",
      "icon": "source_environment",
      "comment": "Опис для Ресурси"
    },
    {
      "position": 3,
      "type_id": 8020,
      "slug": "deals",
      "type": "Угоди",
      "icon": "handshake",
      "comment": "Опис для Угоди"
    },{
      "position": 4,
      "type_id": 7010,
      "slug": "force-majeure",
      "type": "Форс мажор",
      "icon": "nearby_error",
      "comment": "Опис для Форс мажор"
    }]
  },{
    "questName":"Лёгкие и кислород",
    "type_id": 2,
    "fields":[
    {
      "position": 1,
      "type_id": 8040,
      "slug": "force-majeure",
      "type": "Форс мажор",
      "icon": "nearby_error",
      "comment": "Опис для Форс мажор"
    },{
      "position": 2,
      "type_id": 7080,
      "slug": "resources",
      "type": "Ресурси",
      "icon": "source_environment",
      "comment": "Опис для Ресурси"
    },
    {
      "position": 3,
      "type_id": 8020,
      "slug": "deals",
      "type": "Угоди",
      "icon": "handshake",
      "comment": "Опис для Угоди"
    },{
      "position": 4,
      "type_id": 7010,
      "slug": "force-majeure",
      "type": "Форс мажор",
      "icon": "nearby_error",
      "comment": "Опис для Форс мажор"
    }]
  },{
    "questName":"Сердце и сосуды",
    "type_id": 1,
    "fields":[{
      "position": 1,
      "type_id": 8080,
      "slug": "resources",
      "type": "Ресурси",
      "icon": "source_environment",
      "comment": "Опис для Ресурси"
    },
    {
      "position": 2,
      "type_id": 8040,
      "slug": "force-majeure",
      "type": "Форс мажор",
      "icon": "nearby_error",
      "comment": "Опис для Форс мажор"
    },
    {
      "position": 3,
      "type_id": 8020,
      "slug": "deals",
      "type": "Угоди",
      "icon": "handshake",
      "comment": "Опис для Угоди"
    }]
  }],
  difficultyLevelsEmpty: {
	first: {
			points: 0,
			maxPoints: 0,
			fields: [],
      history: [],
			isViewPopap: false
	},
	second: {
			points: 0,
			maxPoints: 0,
			fields: [],
      history: [],
			isViewPopap: true
	},
	third: {
			points: 0,
			maxPoints: 0,
			fields: [],
      history: [],
			isViewPopap: true
	},
	fourth: {
			points: 0,
			maxPoints: 0,
			fields: [0],
      history: [],
			isViewPopap: true
	},
	fifth: {
			points: 0,
			maxPoints: 0,
			fields: [0],
      history: [],
			isViewPopap: true
	},
	sixth: {
			points: 0,
			maxPoints: 0,
			fields: [0],
      history: [],
			isViewPopap: true
	},
	seventh: {
			points: 0,
			maxPoints: 0,
			fields: [0],
      history: [],
			isViewPopap: true
	}
},
levelPDFTitle:[{
  level: 1,
  title: 'txtPDF1'
},{
  level: 2,
  title: 'txtPDF2'
},{
  level: 3,
  title: 'txtPDF3'
}]
}